// extracted by mini-css-extract-plugin
export default {"claims-table":"FFF96E4G","claimsTable":"FFF96E4G","without-consumer-action-status-column":"njOedhVT","withoutConsumerActionStatusColumn":"njOedhVT"};